import { getFreeTrialPropertiesAsync } from './getFreeTrialPropertiesAsync'

export const isFreeTrialEligibleAsync = async (refresh = false) => {
  const { eligible } = await getFreeTrialPropertiesAsync(refresh)

  return !!eligible
}
